// Shared
export const SET_LOADING = 'SET_LOADING';
export const SET_ERROR = 'SET_ERROR';
export const CLEAR_ERROR = 'CLEAR_ERROR';
export const SET_SUCCESS = 'SET_SUCCESS';

export const SET_LAT = 'SET_LAT';
export const SET_LNG = 'SET_LNG';

export const SET_SWIPPER = 'SET_SWIPPER';





// WEBPACK FOOTER //
// ./src/store/mutation-types.js